module.exports = "/_next/static/images/icon_footer-aafc45e5e18ab9d3f6fceb7cf0daef90.png";